import { HttpClient } from '@angular/common/http';
    import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';
    declare const Pusher: any;
    @Injectable()
    export class PusherServiceProvider {
    channel;
    constructor(public http: HttpClient) {
    var pusher = new Pusher(APIService.PUSHER_KEY, 
      {
        cluster: APIService.PUSHER_CLUSTER,
        encrypted: true
      }
    );
    this.channel = pusher.subscribe(APIService.PUSHER_CHANNEL+APIService.PUSHER_AMBIENTE);
    }
    public init(){
      return this.channel;
      }
    }